import React, { useContext } from 'react';
import { BusinessDataFormContext } from '../BusinessDataForm';
import { IEditMenuAction } from '../Utils/BusinessDataFormUtils';
import EDButton from '../../../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIcon from '../../../../../../../BaseComponents/Icon/EDIcon';
import { MdDetailSelectionContext } from '../../../../../../../Components/MasterDetail/Contexts/MdDetailSelectionContext';
import { useWidth } from '../../../../../../../Components/BreakpointContext/BreakpointContextUtils';

interface IProps {
  editMenuAction: IEditMenuAction;
  onCancel?: () => void;
}

const BusinessDataFormEditMenuActionButton: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const formContext = useContext(BusinessDataFormContext);
  const detailSelectionContext = useContext(MdDetailSelectionContext);
  const width = useWidth();

  if (formContext == null) {
    return null;
  }

  const actionParams = {
    businessDataFormContext: formContext,
    editMenuOnCancel: props.onCancel,
    selectDetail: detailSelectionContext.selectDetail,
  };
  const hidden = props.editMenuAction.isHidden?.(actionParams);
  const disabled = props.editMenuAction.isDisabled?.(actionParams);
  const label =
    typeof props.editMenuAction.label === 'function'
      ? props.editMenuAction.label(actionParams)
      : props.editMenuAction.label;

  const shortLabel =
    typeof props.editMenuAction.shortLabel === 'function'
      ? props.editMenuAction.shortLabel(actionParams)
      : props.editMenuAction.shortLabel;

  const flat =
    typeof props.editMenuAction.flat === 'function'
      ? props.editMenuAction.flat(actionParams)
      : (width === 'xs' && !props.editMenuAction.primary) ||
        props.editMenuAction.flat;

  if (hidden) {
    return null;
  } else {
    return (
      <EDButton
        key={props.editMenuAction.id}
        label={label}
        shortLabel={shortLabel}
        marginX={1}
        onClick={() => {
          props.editMenuAction.onClick(actionParams);
        }}
        primary={props.editMenuAction.primary}
        disabled={Boolean(disabled)}
        disabledReason={typeof disabled !== 'boolean' ? disabled : undefined}
        smartPhoneActionButton={width === 'xs'}
        flat={flat}
        icon={
          props.editMenuAction.icon &&
          !props.editMenuAction.hideIconIfNotFloating && (
            <EDIcon
              iconType={props.editMenuAction.icon}
              marginRight={1}
              color={'inherit'}
              size="small"
            />
          )
        }
        testId={props.editMenuAction.id}
      />
    );
  }
};

export default BusinessDataFormEditMenuActionButton;
